module.exports = __webpack_public_path__ + "img/album16_02.c4f323c9.jpg";